import { AllCommentsTable } from "@/components/comments/AllCommentsTable";

export default function AllCommments() {
	return (
		<div className="flex items-center h-full pt-10 flex-col">
			<AllCommentsTable />
		</div>
	);
}